import { BrowserRouter } from 'react-router-dom'
import { LanguageProvider } from '@/i18n/LanguageContext'
import { Header } from '@/sections/Header'
import { Hero } from '@/sections/Hero'
import { Sobre } from '@/sections/Sobre'
import { Servicos } from '@/sections/Servicos'
import { Diferenciais } from '@/sections/Diferenciais'
import { Tecnologias } from '@/sections/Tecnologias'
import { ExperienciaCorporativa } from '@/sections/ExperienciaCorporativa'
import { PorQueEscolher } from '@/sections/PorQueEscolher'
import { Contato } from '@/sections/Contato'
import { Footer } from '@/sections/Footer'
import { FloatingWhatsApp } from '@/components/FloatingWhatsApp'

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <div className="min-h-screen flex flex-col overflow-x-hidden">
          <Header />
          <main>
            <Hero />
            <Sobre />
            <Servicos />
            <Diferenciais />
            <Tecnologias />
            <ExperienciaCorporativa />
            <PorQueEscolher />
            <Contato />
            <Footer />
          </main>
          <FloatingWhatsApp />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  )
}

export default App
